import React, { useRef } from "react";

export const OTPInput = ({ value, onChange, length = 6 }) => {
  const refs = useRef([]);

  const handleChange = (i, v) => {
    const digit = v.replace(/\D/g, "").slice(-1);
    const chars = (value || "").padEnd(length, " ").split("");
    chars[i] = digit || " ";
    const next = chars.join("").replace(/ /g, "");
    onChange(next.slice(0, length));
    if (digit && i < length - 1) refs.current[i + 1]?.focus();
  };

  const handleKey = (i, e) => {
    if (e.key === "Backspace" && !value[i] && i > 0) {
      refs.current[i - 1]?.focus();
    }
  };

  return (
    <div className="flex justify-center gap-2" data-testid="otp-input">
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          inputMode="numeric"
          maxLength={1}
          value={value[i] || ""}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKey(i, e)}
          data-testid={`otp-digit-${i}`}
          className="h-12 w-12 rounded-xl border border-slate-200 bg-white text-center text-xl font-bold text-slate-900 outline-none transition-all focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
        />
      ))}
    </div>
  );
};
